var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgU(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE3\x82\xA6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M52.928 15.04L56.384 17.216C56.064 18.112 55.68 19.84 55.488 21.056C54.592 26.176 52.736 34.176 49.152 40.256C44.416 48.64 35.584 55.168 23.872 58.368L19.712 53.632C21.824 53.248 24.256 52.608 26.304 51.84C32.768 49.728 39.744 44.992 43.712 38.912C47.168 33.472 49.152 25.728 49.728 20.288H14.016H8.89602V20.16C8.89602 18.816 8.89602 16.64 8.64001 15.296C10.3168 15.4117 12.0459 15.5273 14.016 15.5485C14.2265 15.5508 14.4398 15.552 14.656 15.552H48.576C50.944 15.552 52.096 15.296 52.928 15.04Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace",
    d: "M8.5 18H53C49.3799 43.6952 38.8936 51.6854 20 56.5",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stroke 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_2",
    d: "M8.89602 20.16C8.89602 18.816 8.89602 16.64 8.64001 15.296C10.3168 15.4117 12.0459 15.5273 14.016 15.5486V20.288V31.744C14.016 32.832 14.08 34.56 14.208 35.52H8.64001C8.83202 34.432 8.89602 32.704 8.89602 31.424V20.288V20.16Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace_2",
    d: "M11.5 15V36",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stroke 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_3",
    d: "M28.48 4.79999H34.56C34.304 6.78399 34.24 8.25599 34.24 9.59999V18.112H28.8V9.59999C28.8 8.25599 28.736 6.78399 28.48 4.79999Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace_3",
    d: "M31.5 4.5V18.5",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgU);
export default __webpack_public_path__ + "static/media/u.8d3b16a5eefca30f115a8629bc1ff7a0.svg";
export { ForwardRef as ReactComponent };